var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 705,
    height: 401,
    viewBox: "0 0 705 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704.852 379.35C704.852 379.35 699.452 383.4 697.902 390C696.352 396.6 690.602 401 690.602 401",
    stroke: "url(#paint0_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 361.35C704.852 361.35 686.352 367.05 681.452 381.4C676.752 395.35 657.752 401 657.752 401",
    stroke: "url(#paint1_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 343.35C704.852 343.35 673.252 350.7 665.052 372.75C657.152 394 624.902 401 624.902 401",
    stroke: "url(#paint2_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 325.3C704.852 325.3 660.202 334.35 648.602 364.1C637.552 392.7 592.102 401 592.102 401",
    stroke: "url(#paint3_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 307.3C704.852 307.3 647.102 318 632.202 355.45C617.952 391.35 559.252 401 559.252 401",
    stroke: "url(#paint4_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 289.3C704.852 289.3 634.002 301.65 615.752 346.85C598.352 390 526.402 401 526.402 401",
    stroke: "url(#paint5_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 271.25C704.852 271.25 620.952 285.3 599.352 338.15C578.752 388.7 493.552 401 493.552 401",
    stroke: "url(#paint6_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 253.25C704.852 253.25 607.852 268.95 582.902 329.55C559.152 387.35 460.702 401 460.702 401",
    stroke: "url(#paint7_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 235.25C704.852 235.25 594.752 252.6 566.452 320.9C539.552 386 427.902 401 427.902 401",
    stroke: "url(#paint8_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 217.2C704.852 217.2 581.702 236.2 550.052 312.25C519.902 384.7 395.052 401 395.052 401",
    stroke: "url(#paint9_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 199.2C704.852 199.2 568.602 219.9 533.602 303.6C500.302 383.35 362.202 401 362.202 401",
    stroke: "url(#paint10_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 181.2C704.852 181.2 555.502 203.55 517.202 295C480.702 382 329.352 401 329.352 401",
    stroke: "url(#paint11_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 163.15C704.852 163.15 542.452 187.15 500.752 286.3C461.102 380.7 296.552 401 296.552 401",
    stroke: "url(#paint12_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 145.15C704.852 145.15 529.352 170.8 484.352 277.65C441.502 379.35 263.702 401 263.702 401",
    stroke: "url(#paint13_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 127.1C704.852 127.1 516.252 154.45 467.902 269C421.902 378 230.852 401 230.852 401",
    stroke: "url(#paint14_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 109.1C704.852 109.1 503.202 138.1 451.502 260.35C402.302 376.7 198.002 401 198.002 401",
    stroke: "url(#paint15_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 91.1C704.852 91.1 490.101 121.75 435.051 251.75C382.702 375.35 165.151 401 165.151 401",
    stroke: "url(#paint16_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 73.05C704.852 73.05 477.002 105.4 418.602 243.05C363.102 374 132.352 401 132.352 401",
    stroke: "url(#paint17_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 55.05C704.852 55.05 463.952 89.05 402.202 234.45C343.502 372.7 99.5015 401 99.5015 401",
    stroke: "url(#paint18_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 37.0499C704.852 37.0499 450.852 72.7 385.752 225.8C323.902 371.35 66.6516 401 66.6516 401",
    stroke: "url(#paint19_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 19C704.852 19 437.752 56.3 369.352 217.15C304.302 370 33.8016 401 33.8016 401",
    stroke: "url(#paint20_linear_2073_1246)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.852 1C704.852 1 424.702 40 352.902 208.5C284.702 368.7 1.00153 401 1.00153 401",
    stroke: "url(#paint21_linear_2073_1246)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2073_1246",
    x1: 697.727,
    y1: 401,
    x2: 697.727,
    y2: 379.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2073_1246",
    x1: 681.302,
    y1: 401,
    x2: 681.302,
    y2: 361.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2073_1246",
    x1: 664.877,
    y1: 401,
    x2: 664.877,
    y2: 343.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2073_1246",
    x1: 648.477,
    y1: 401,
    x2: 648.477,
    y2: 325.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2073_1246",
    x1: 632.052,
    y1: 401,
    x2: 632.052,
    y2: 307.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2073_1246",
    x1: 615.627,
    y1: 401,
    x2: 615.627,
    y2: 289.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2073_1246",
    x1: 599.202,
    y1: 401,
    x2: 599.202,
    y2: 271.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2073_1246",
    x1: 582.777,
    y1: 401,
    x2: 582.777,
    y2: 253.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2073_1246",
    x1: 566.377,
    y1: 401,
    x2: 566.377,
    y2: 235.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2073_1246",
    x1: 549.952,
    y1: 401,
    x2: 549.952,
    y2: 217.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2073_1246",
    x1: 533.527,
    y1: 401,
    x2: 533.527,
    y2: 199.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2073_1246",
    x1: 517.102,
    y1: 401,
    x2: 517.102,
    y2: 181.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2073_1246",
    x1: 500.702,
    y1: 401,
    x2: 500.702,
    y2: 163.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2073_1246",
    x1: 484.277,
    y1: 401,
    x2: 484.277,
    y2: 145.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2073_1246",
    x1: 467.852,
    y1: 401,
    x2: 467.852,
    y2: 127.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2073_1246",
    x1: 451.427,
    y1: 401,
    x2: 451.427,
    y2: 109.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2073_1246",
    x1: 435.002,
    y1: 401,
    x2: 435.001,
    y2: 91.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2073_1246",
    x1: 418.602,
    y1: 401,
    x2: 418.602,
    y2: 73.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2073_1246",
    x1: 402.177,
    y1: 401,
    x2: 402.177,
    y2: 55.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2073_1246",
    x1: 385.752,
    y1: 401,
    x2: 385.752,
    y2: 37.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2073_1246",
    x1: 369.327,
    y1: 401,
    x2: 369.327,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2073_1246",
    x1: 352.927,
    y1: 401,
    x2: 352.927,
    y2: 1.00003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9);
export default __webpack_public_path__ + "static/media/Group (9).3b52b3465d6d792b0ccfe624d8f28de3.svg";
export { ForwardRef as ReactComponent };